/* eslint-disable camelcase */
import { API_PREFIX } from '../../shared/constants';
import { createRestClient, assertStatusCode } from '../shared/rest';
import { OrderReturnRequest, OrderReturnResponse } from '@pegasus/types/session';
import { Order } from 'types/order';

export interface OrdersResponse {
    results: Order[];
}

export interface OrderResponse {
    results: Order;
}

export interface FetchOrdersParams {
    created_until?: string;
}

export interface CancelOrdersResponse {
    results: any;
}

export const fetchOrders = (params: string | FetchOrdersParams = ''): Promise<OrdersResponse> => {
    const client = createRestClient(API_PREFIX);
    return client
        .get(
            typeof params === 'string' ? `/orders?${params}` : '/orders',
            typeof params === 'string' ? undefined : params,
        )
        .then(assertStatusCode([200]))
        .then(response => response.json());
};

export const fetchOrder = (orderNumber: string): Promise<OrderResponse> => {
    const client = createRestClient(API_PREFIX);

    return client
        .get(`/orders/${orderNumber}`)
        .then(assertStatusCode([200]))
        .then(response => response.json());
};

export const cancelOrders = (orderId: string, itemIds: string[]): Promise<CancelOrdersResponse> => {
    const client = createRestClient(API_PREFIX);

    return client
        .post(`/orders/${orderId}/cancellations`, {}, { itemIds })
        .then(assertStatusCode([200]))
        .then(response => response.json())
        .then(data => ({
            results: data,
        }));
};

export const fetchOrderReturnSession = (
    orderNumber: string,
    returnPage: string,
): Promise<OrderReturnResponse> => {
    const client = createRestClient(API_PREFIX);
    return client
        .get(`/sessions/${orderNumber}?returnPage=${returnPage}`)
        .then(assertStatusCode([200]))
        .then(response => response.json())
        .then(response => response.results);
};

export const updateOrderReturnSession = (
    orderNumber: string,
    patch: OrderReturnRequest,
): Promise<OrderReturnResponse> => {
    const client = createRestClient(API_PREFIX);
    return client
        .put(`/sessions/${orderNumber}`, {}, patch)
        .then(assertStatusCode([200]))
        .then(response => response.json())
        .then(response => response.results);
};

export const getOrderReturnLabel = (orderNumber: string): Promise<Blob> => {
    const client = createRestClient(API_PREFIX);
    return client
        .get(`/sessions/${orderNumber}/label`)
        .then(assertStatusCode([200]))
        .then(response => response.blob());
};

export const sendOrderReturnEmail = (orderNumber: string): Promise<{}> => {
    const client = createRestClient(API_PREFIX);
    return client
        .post(`/sessions/${orderNumber}/email`)
        .then(assertStatusCode([200]))
        .then(response => response.json());
};
